import React, { Component } from 'react';
import {Button, ButtonGroup, Container, Table} from 'reactstrap';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import { withRouter } from 'react-router-dom';
import AppNavbar from '../AppNavbar.js';
import './users.css';
import '../css/alum-style.css';

class UserList extends Component {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) {
        super(props);
        const {cookies} = props;
        this.state = {groups: [], csrfToken: cookies.get('XSRF-TOKEN'), isLoading: true};
        this.remove = this.remove.bind(this);
    }

    async componentDidMount() {
        this.setState({isLoading: true});

        await fetch('/alumsum/users', {credentials: 'include'})
            .then(async response => response.json())
            .then(data => this.setState({groups: data, isLoading: false}))
            .catch(() => this.props.history.push('/'));

            console.log(this.state.groups);
    }

    async remove(id) {
        await fetch(`/alumsum/user/${id}`, {
            method: 'DELETE',
            headers: {
                'X-XSRF-TOKEN': this.state.csrfToken,
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            credentials: 'include'
        }).then(() => {
            let updatedGroups = [...this.state.groups].filter(i => i.id !== id);
            this.setState({groups: updatedGroups});
        });
    }

    render() {
        const {groups, isLoading} = this.state;

        if (isLoading) {
            return <p>Loading...</p>;
        }

        const groupList = groups.map(group => {
            return <tr key={group.id}>
                <td>{group.firstName}</td>
                <td>{group.lastName}</td>
                <td>{group.userName}</td>
                <td>{group.userEmail}</td>
                <td>{group.userPhoneNumber}</td>
                <td>
                    <ButtonGroup>
                        <Button size="sm" className="userButton" color="primary" to={"/alumsum/user/" + group.id}>Edit</Button>
                        <Button size="sm" className="userButton" color="danger" onClick={() => this.remove(group.id)}>Delete</Button>
                    </ButtonGroup>
                </td>
            </tr>
        });

        return (
            <div>
                <AppNavbar/>
                {/*<div className="navbar-nav ml-auto" >*/}
                {/*    <NavItem>*/}
                {/*        <NavLink*/}
                {/*            to={Plaid} ><Plaid img src={plaid}/> Link Your Student Loan Accounts</NavLink>*/}
                {/*    </NavItem>*/}
                {/*</div>*/}
                <Container fluid>
                    <div className="float-right">
                        <Button color="success" className="addUserButton" to="/alumsum/user/new">Add User</Button>
                    </div>
                    <h3>AlumSum Users</h3>
                    <Table className="mt-4">
                        <thead>
                        <tr>
                            <th>First Name</th>
                            <th>Last Name</th>
                            <th>User Name</th>
                            <th>Email</th>
                            <th>Phone</th>
                        </tr>
                        </thead>
                        <tbody>
                        {groupList}
                        </tbody>
                    </Table>
                </Container>
            </div>
        );
    }
}
export default withCookies(withRouter(UserList));